module.exports = __webpack_public_path__ + "0cfda4d7188f3b8fd50c7b294f35b561.svg";